
    import {Options, Prop, Vue} from 'vue-property-decorator';

    @Options({})
    export default class ProfileCreationStepCounter extends Vue {
        @Prop({type: Boolean, default: false})
        pushLeft!: boolean;

        get stepNumber(): number {
            return this.$router.currentRoute.value.meta.stepNumber;
        }

        get nbSteps(): number {
            return this.$router.currentRoute.value.meta.stepCount;
        }
    }
